export abstract class TunnelData {
  abstract init();
  abstract initFromConfig(config: any);
}
